if (!customElements.get('cart-count')) {
  class CartCount extends HTMLElement {
    constructor() {
      super();
      this.handlerRef = this.handleChange.bind(this);
    }

    handleChange(event) {
      if (!event.detail.json.hasOwnProperty('item_count')) return;
      this.innerText = event.detail.json.item_count > 0 ? event.detail.json.item_count : '';
    }

    disconnectedCallback() {
      document.removeEventListener('alexa:update-cart', this.handlerRef);
    }

    connectedCallback() {
      document.addEventListener('alexa:update-cart', this.handlerRef);
    }
  }

  customElements.define('cart-count', CartCount);
}
